import React, { useCallback } from 'react';
import { useFormikContext } from 'formik';

import { useStore } from 'core/store/';
import { Discount } from '../discount';
import { track } from 'core/helpers/analytics';

const discountConfig = {
  legacy_savings: {
    formField: 'global.legacyDiscount',
    storeMethod: 'setIncludeLegacyDiscount',
    trackingName: 'Legacy Discount'
  },
  military_savings: {
    formField: 'global.militaryDiscount',
    storeMethod: 'setIncludeMilitaryDiscount',
    trackingName: 'Military Discount'
  },
  education_savings: {
    formField: 'global.educationDiscount',
    storeMethod: 'setIncludeEducationDiscount',
    trackingName: 'Education Discount'
  },
  crop_insurance_savings: {
    formField: 'global.cropInsuranceDiscount',
    storeMethod: 'setIncludeCropInsuranceDiscount',
    trackingName: 'Crop Insurance Discount'
  },
  traditions_savings: {
    formField: 'global.traditionsDiscount',
    storeMethod: 'setIncludeTraditionsDiscount',
    trackingName: 'Traditions Discount'
  },
  association_savings: {
    formField: 'global.farmAssociationDiscount',
    storeMethod: 'setIncludeAssociationDiscount',
    trackingName: 'Association Discount'
  }
};

const FarmDiscount = ({ isActive, id, ...discount }) => {
  const { setFieldValue, values } = useFormikContext();
  const { offer: store } = useStore();

  const config = discountConfig[id];
  const fieldPath = config.formField.split('.');
  const isApplied = fieldPath.reduce((obj, key) => obj?.[key], values) ?? isActive;
  const state = store.offer?.quote?.correctedAddress?.state;

  const onAddClick = useCallback(() => {
    setFieldValue(config.formField, true);
    store[config.storeMethod](true);
    track(`${config.trackingName} Added`, {
      discount: discount.label,
      offerId: store.offer?.id,
      state
    });
  }, [setFieldValue, store, config, discount.label, state]);

  const onRemoveClick = useCallback(() => {
    setFieldValue(config.formField, false);
    store[config.storeMethod](false);
    track(`${config.trackingName} Removed`, {
      discount: discount.label,
      offerId: store.offer?.id,
      state
    });
  }, [setFieldValue, store, config, discount.label, state]);

  return <Discount {...discount} id={id} isActive={isApplied} onAdd={onAddClick} onRemove={onRemoveClick} />;
};

export default FarmDiscount;
